import CartItemSmall from "./CartItemSmall";
import { getValue } from "@/utils/storage";
import { memo } from "react";
import { Product } from "@/types/product";
import { UnifiedMessage } from "@/hooks/use-messages";

type ProductMessageProps = {
  message: UnifiedMessage;
  setProductDescription: (product: Product) => void;
};

const propsAreEqual = (
  prevProps: ProductMessageProps,
  nextProps: ProductMessageProps,
) => {
  const isSameProduct =
    prevProps.message.text === nextProps.message.text &&
    prevProps.message.message === nextProps.message.message;
  const isSameSetter =
    prevProps.setProductDescription === nextProps.setProductDescription;

  // Only re-render if the message text has changed
  return isSameProduct || isSameSetter;
};

export const ProductMessage = memo(function ProductMessage({
  message,
  setProductDescription,
}: ProductMessageProps) {
  const productReferenceInLocalStorage = message.message || message.text;

  if (!productReferenceInLocalStorage) {
    return null;
  }

  const productsArray = JSON.parse(
    getValue(productReferenceInLocalStorage) || "[]",
  );

  if (productsArray.length === 0) {
    return null;
  }

  return (
    <div className="w-full mb-4 flex items-start justify-start">
      <div className="nut-grid !grid-cols-2 gap-[16px] mt-[16px]">
        {productsArray.slice(0, 2).map((product: Product) => (
          <CartItemSmall
            key={product.id}
            image={product?.images[0].src}
            imageAlt="cart image 1"
            title={product.title}
            currentPrice={product?.variants?.[0]?.price}
            onClick={() => setProductDescription(product)}
          />
        ))}
      </div>
    </div>
  );
}, propsAreEqual);
